import { Box, Button } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { publishTableColumn } from "components/PimDashboard/data";
import { projectionDummyData, storeProjectionColumns } from "./data";
import { useEffect, useState } from "react";
import ProjectionAllStoresModal from "./ProjectionAllStoresModal/ProjectionAllStoresModal";
import { converAttrToDatagridCol, createdByColumns } from "data/globalData";
import { statusOptions } from "data/globalData";
import { allowAccess } from "utils/userAccessFun";
import { custom, departments } from "data/authData";
import { AuthState } from "context/AuthContext";
import CreateModal from "./CreateModal/CreateModal";
import { GlobalState } from "context/GlobalContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import axios from "axios";

const StoreProjections = () => {
	const { user } = AuthState();
	const { setLoadingOpen, setSnackBarOpen, setSnackBar, snackBar } = GlobalState();
	const handlePublishClick = (row) => {
		const updatedRow = { ...row, status: statusOptions.PUBLISHED.key };
		// handleUpdateDetails(updatedRow);
	};

	const fetch = async () => {
		setLoadingOpen(true);

		try {
			await axios.get(`/api/color_buying/season_grt_projection`).then((res) => {
				setTableArr(res.data?.result);
			});
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	useEffect(() => {
		fetch();
	}, []);
	const [tableColumns, setTableColumns] = useState([
		...storeProjectionColumns.map((row) => converAttrToDatagridCol(row)),
		...createdByColumns.map((row) => converAttrToDatagridCol(row)),
		publishTableColumn(handlePublishClick, !allowAccess(custom.STYLE_PUBLISHER, user, departments.DESIGNER.key)),
	]);
	const [tableArr, setTableArr] = useState(projectionDummyData);
	const [infoModal, setInfoModal] = useState(false);
	const [createModal, setCreateModal] = useState(false);
	const [selectedProjection, setSelectedProjection] = useState();

	const handleInfoModalOpen = (row) => {
		setInfoModal(true);
		setSelectedProjection(row);
	};
	const handleCreateModalOpen = (row) => {
		setCreateModal(true);
	};
	return (
		<Box display="flex" width="90vw" flexWrap="wrap" margin="auto">
			<Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
				{/* <Typography variant="h6">Users</Typography> */}
				<Box>
					<Button size="small" variant="contained" onClick={handleCreateModalOpen}>
						Create
					</Button>
				</Box>
			</Box>
			<Box pt={1} width="100%">
				<DataGrid
					rows={tableArr ?? []}
					columns={tableColumns ?? []}
					sx={{
						height: "70vh",
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
						"& .MuiDataGrid-footer": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					disableAutosize
					onRowClick={({ row }) => handleInfoModalOpen(row)}
					// disableRowSelectionOnClick
					pageSizeOptions={[5, 10]}
				/>
			</Box>
			{infoModal && <ProjectionAllStoresModal modal={infoModal} setModal={setInfoModal} selectedObj={selectedProjection} />}
			{createModal && <CreateModal modal={createModal} setModal={setCreateModal} />}
		</Box>
	);
};

export default StoreProjections;
